import * as React from 'react';

import {useQuery, useApolloClient} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetBroadcast as GetBroadcastQuery,
    GetBroadcastVariables as GetBroadcastQueryVariables,
    BroadcastFragment as Broadcast,
    BroadcastStubFragment as BroadcastStub,
} from 'nutshell-graphql-types';

import BROADCAST_STUB_FRAGMENT from './graphql/fragments/broadcast-stub-fragment.graphql';
import GET_BROADCAST from './graphql/queries/get-broadcast.graphql';

type Props = {
    broadcastId: string;
    children: (arg1: {
        broadcast: Broadcast | null | undefined;
        broadcastStub: BroadcastStub | null | undefined;
        isLoading: boolean;
        error: string | null | undefined;
    }) => React.ReactElement;
};

export function BroadcastQuery(props: Props) {
    const client = useApolloClient();
    let broadcastStub: BroadcastStub | null | undefined;

    try {
        broadcastStub = client.readFragment({
            id: props.broadcastId,
            fragmentName: 'BroadcastStubFragment',
            fragment: BROADCAST_STUB_FRAGMENT,
        });
    } catch {
        // Empty
    }

    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetBroadcastQuery, GetBroadcastQueryVariables>(GET_BROADCAST, {
        variables: {broadcastId: props.broadcastId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    const broadcast = data ? data.broadcast : null;

    return props.children({
        broadcast,
        broadcastStub,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    });
}
